import React from "react";
import Page from "../components/Page";

const About = () => <Page title="About Us">this is the About</Page>;

export default About;
